import React, { useEffect, useState,} from 'react'
import '../styles/program.scss'
import _, { forEach, groupBy, includes } from 'lodash'


import moment from 'moment'

import { useHistory } from 'react-router-dom'

//import check from "./images/check-mark.svg";
//import checkIcon from "./images/check-mark.svg";
import Region from './Region';
import Cinema from './Cinema';
//import Sorting from './Sorting';
//import LOCALES from '../overlays/OverlayLocales'
//import da from "date-fns/locale/da";

import { useLocation } from "react-router-dom";





export default function AllFutureFilmsContainer({ allMovies, allEvents, allOrganizers, locations, ageCensor, allEventsTypes, backTo, site_type, iframeId }) {
    const location = useLocation();
    
    const history = useHistory();
   
    const [showCalendar, setShowCalendar] = useState(false)
  
    const [noFilmError, setNoFilmError] = useState([]);
    const [calendarDate, setCalendarDate] = useState(new Date());
   // const [ filteredMovies, setFilteredMovies] = useState([])
    const [selectedDate, setSelectedDate] = useState(moment().format('DD-MM-YYYY'))
    const [selected, setSelected] = useState(1);

   
    const [isOpen, setIsOpen] = useState(false);
 
    const [cinemaID, setCinemaID] = useState(0)
    const [orgPerRegion, setOrgPerRegion] = useState([])
    const [resetCinema, setResetCinema] = useState(false)
    const [regarr, setRegarr] = useState(localStorage.getItem('reg_arr') ? localStorage.getItem('reg_arr').split(',') : [])
    const [cinemaarr, setCinemaarr] = useState(localStorage.getItem('cinema_arr') ? localStorage.getItem('cinema_arr').split(',') : [])
    const [cinemaIds, setCinemaIds] = useState([])
  
    const [sortedEvents, setSortedEvents] = useState([])
    let evs = []
    let ev = []
   
    useEffect(() => {
        setCinemaIds(cinemaarr.map(cinema => allOrganizers.find(o => o.name === cinema)._no))
    }, [cinemaarr])

    let filteredMovies 
    let am=[]
    allMovies.map((movie) => {
        if (moment(movie.openingDate).isAfter()) {
           am.push({ movie })
        }
    })
    
  
    // ----------Calculating MOST PROGRAMMED MOVIE---------------
    let moviesWithEvents = []
   
    function findOcc(arr, key) {
     
        let arr2 = [];

        arr.forEach((x) => {

            // Checking if there is any object in arr2 
            // which contains the key value 
            if (arr2.some((val) => { return val[key] == x[key] })) {

                // If yes! then increase the occurrence by 1 
                arr2.forEach((k) => {
                    if (k[key] === x[key]) {
                        k["occurrence"]++
                    }
                })

            } else {
                // If not! Then create a new object initialize  
                // it with the present iteration key's value and  
                // set the occurrence to 1 
                let a = {}
                a[key] = x[key]
                a["occurrence"] = 1
                arr2.push(a);
            }
        })

        return arr2, moviesWithEvents.push(arr2)

    }
   
    

    /**----------CATCHING ERROR HERE IF CERTAIN BIOGRAF DOES NOT HAVE MOVIE ON SELECTED DATE---------- */
    useEffect(() => {
        if (cinemaIds.length && !ev.length) {
            setNoFilmError('ingen film hos valgte biograf i valget dato')
        }
        else setNoFilmError('')
        }, [cinemaIds, ev])
 

    useEffect(() => {
        if (regarr.length > 0 && !evs.length) {
            setNoFilmError('ingen film i valgte region')
        }
    }, [evs, regarr])

   
    /**------Gettting the filtered regions here ------------- */
    let filteredRegion = []  // contains filtered regions from choose region field
    regarr.forEach(checkReg);
    
    function checkReg(item) {
        allOrganizers.filter(org => {
            if (org.region == item) filteredRegion.push(org)
        })
    }
  
    allEvents.map(e => {
        filteredRegion.map(reg => {

            if ((reg._no === e._organizerNo) ) {
                evs.push(e)             
            }
        })
    })
   // console.log(evs, 'evs')
    useEffect(() => {
        evs && setSortedEvents(evs)
    }, [ regarr])
   // console.log(evs, 'evs')


    /**-----GETTING FILTERED BIOGRAFS HERE------- */
    let filteredCinemas = []
    cinemaIds.forEach(checkCinemaIds)

    function checkCinemaIds(item) {
        allOrganizers.filter(org => {
            if (org._no === item) filteredCinemas.push(org)
        })
    }
  
        allEvents.map(event => {
            filteredCinemas.map(cinema => {
                if (event._organizerNo === cinema._no ) {
                
                    ev.push(event)
                }
            })
        })

    useEffect(() => {
        ev.length && setSortedEvents(ev)
    }, [cinemaIds, ])
  
   

    let comingFilmLists = [{}]
   
    let eventsForFilter = (cinemaIds.length || regarr.length) && sortedEvents.length ? sortedEvents : allEvents
   // console.log(eventsForFilter)
    let eventsPerDay = [{}]
    eventsForFilter.map((e) => {
  
          
              allMovies.map((m) => {
               
                  if (m._no === e._movieNo && moment(m.openingDate).isAfter()) {
                      comingFilmLists.push(m)
                       // showsPerDay.push(m)
                        eventsPerDay.push(e)
                    }           
               
            })
      
    })

   
   
    filteredMovies = toFindDuplicates(comingFilmLists)

    filteredMovies.map((movie) => {
        eventsPerDay.map((ev) => {
            //let hasShows = false
            if (ev._movieNo === movie._no) {
                //hasShows = true
                 //console.log(movie)
                Object.assign(movie, { hasShows: movie._no == ev._movieNo ? true : false })

            }

        })

    })
    
    findOcc(eventsPerDay, '_movieNo')  // findOcc function counts how many times a movie occurs in allEvents

    //find duplicates
  
    function toFindDuplicates(showsPerDay) {
        const uniqueElements = new Set(showsPerDay);

        showsPerDay.filter((item) => {
            if (uniqueElements.has(item)) {

            } else {
                return item;
            }
        });

        return [...new Set(uniqueElements)];
    }

  
  

  
    
    function handleArrrow() {
        setIsOpen((current) => !current);
    }

    // ----------FILTERING MOVIES WITH CHOOSE REGION----------------- 
  //  console.log(orgPerRegion, 'orgs per region')
    let orgsArr = []

    useEffect(() => {
        orgPerRegion && orgPerRegion.map((org) => {
            // console.log(org._no)
            orgsArr.push(org._no)
        })
    })


    let arr = [];

    allOrganizers.filter((i) => arr.push(i.region))

  


    function handleRegionArrrow() {
        setIsOpen((current) => !current);
    }

    function toggleCalendar() {
        setShowCalendar(true)
    }
    function closeCalendar() {
        setShowCalendar(false)
    }

    /*** folowing function runs when clicked on FLERE DATOER */
    function handleDateClick(e) {
    
        setCalendarDate(new Date(e))
       // console.log(moment(e).format('DD-MM-YYYY'))
        setSelectedDate(moment(e).format('DD-MM-YYYY'))
        closeCalendar();
        setSelected(0)
    }

    function movieArr(id) {
   //  console.log(id)
        let mo = []
        allMovies.map(m => {
            if (m._no == id) {
                mo.push( m )
               
            }
        })
        return mo
    }

   
  

    function handleMovieClick(e, movie) {   
    
     //   const movieData = movieArr(e.target.id)
        //  console.log(movieData, 'movie data')
        let movie_id = e.target.id
       // let eventsWithFilter = eventsForFilter
        //let futureFilms = true
       
        movie_id && history.push(`/film-details?movieid=${movie_id}&sitetype=${site_type}&iframeid=${iframeId}`, { backTo })
       // history.push('/film-details', { movieData, eventsWithFilter, allOrganizers, allEventsTypes, futureFilms })
    }

  //  console.log(eventsForFilter, 'events for filter')

    function isEmpty(obj) {
        for (const prop in obj) {
            if (Object.hasOwn(obj, prop)) {
                return false;
            }
        }

        return true;
    }
    filteredMovies.map((movie) => {
       
        let n = movie.censoring
        const mc = isEmpty(movie.censoring) === false ? _.find(ageCensor, (icon) => { return n.includes(icon.id) }) : null
        
        Object.assign(movie, { censorImage: isEmpty(movie.censoring) === false ?  mc?.image : null})
    
    })

    const [showItem, setShowItem] = useState(null);

    const menuClickHandler = (param) => {
        if (showItem === param) {
            setShowItem(null);
        } else {
            setShowItem(param);
        }
    };

    function handleClkOutside() {

        setShowItem(null)
        setIsOpen(false)
    }

   
    return (
        <>
            {
                showItem || isOpen ?
                    <div className="modal-backdrop" onClick={handleClkOutside}
                        style={{ top: '0px', width: '1920px', height: '100%', background: 'transparent' }}
                    >

                    </div>
                    : ''
            }
        <div className='AllMovies' >
            <section className='FutureFilmsSection'>
                <div className='FutureFilmsHeader'>
              
                    <Region allOrganizers={allOrganizers} setOrgPerRegion={setOrgPerRegion}
                        setResetCinema={setResetCinema} regarr={regarr} setRegarr={setRegarr} showItem={showItem} menuClickHandler={menuClickHandler} />
                       <p style={{width:'22px'} }></p>
                     <Cinema
                        allOrganizers={filteredRegion.length > 0 ? filteredRegion : allOrganizers} cinemaIds={cinemaIds} setCinemaIds={setCinemaIds}
                        setCinemaID={setCinemaID} resetCinema={resetCinema} setResetCinema={setResetCinema} regarr={regarr} cinemaarr={cinemaarr}
                        setCinemaarr={setCinemaarr} showItem={showItem} menuClickHandler={menuClickHandler}/>
                    
              </div>

            </section>

            <p className='futureMovies_title'>Kommende film</p>
         
            <div className='FutureMoviesContainer'>
                {filteredMovies ? filteredMovies.sort(function (a, b) {
                        let x = moment(a.openingDate).format('DD-MM-YYYY')
                        let y = moment(b.openingDate).format('DD-MM-YYYY')
                        let curr = x.split('-').reverse().join();
                        let prev = y.split('-').reverse().join();
                      return curr < prev ? -1 : (curr > prev ? 1 : 0);
                            })
                       .map((movie, index) => { 

                    if (movie.name) {
                        return <div className='FutureMovieListItem' key={index} >

                            <div id={movie._no} className='poster' onClick={(e) => handleMovieClick(e, movie)} >
                                <img id={movie._no} style={{ borderRadius: '16px', cursor: 'pointer' }}  src={'https://poster.ebillet.dk/' + `${movie.largePath}`} alt="movie-banner" />
                                <div className='age-banner'> {isEmpty(movie.censoring) === false ? <img src={movie.censorImage} alt='age-banner' /> : null}
                                </div>
                            </div>

                            <div className='FutureMovieDesc'>
                                <div className='movieInfo'>
                                    <p className='movie-name' >{movie.name}</p>
                                    <p style={{ fontWeight: 500, letterSpacing: '0.54px', fontSize: '18px', fontFamily:'PP Neue Montreal' }}>
                                        Premiere : <span >{moment(movie.openingDate).format('DD') + '.' + ' ' + moment(movie.openingDate).locale('da').format('MMMM YYYY')}</span></p>
                                    <p style={{ marginTop: '-15px', opacity: '0.5', fontSize: '18px', fontWeight: 500, letterSpacing: '0.54px', height: '25px', fontFamily: 'PP Neue Montreal' }}>{isEmpty(movie.genre) === false ? movie.genre : null}</p>

                                   {isEmpty(movie?.synopsis) === false ?
                                        <p dangerouslySetInnerHTML={{ __html: movie.synopsis }} className='movie_desc' ></p>
                                        : null}
                                    <button className='btn' id={movie._no} onClick={(e) => handleMovieClick(e, movie)} >{movie.hasShows === true ? 'Billetter' : 'Læs mere'}</button>
                                </div>
                            </div>
                        </div>
                    }
                })
                    : ''}
            </div>
        </div>
                           
        </>
            )
               
            


        
    
}